import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import * as HomiSettingsSelectors from './homi-settings.selectors';
import { EloSettings } from '@lyceo/shared/homi-settings/util-models';
import { EloActions } from './homi-settings.actions';

@Injectable({
  providedIn: 'root',
})
export class HomiSettingsFacade {
  private readonly store: Store = inject(Store);

  public eloSettings: Signal<EloSettings | undefined> = this.store.selectSignal(
    HomiSettingsSelectors.selectEloSettings,
  );
  public eloDisplayValue: Signal<string | undefined> = this.store.selectSignal(
    HomiSettingsSelectors.selectEloDisplayValue,
  );
  public pupilId: Signal<string | undefined> = this.store.selectSignal(
    HomiSettingsSelectors.selectPupilId,
  );
  public eloSettingsUri: Signal<string | undefined> = this.store.selectSignal(
    HomiSettingsSelectors.selectEloSettingsUri,
  );
  public refreshSettingsLoading: Signal<boolean> = this.store.selectSignal(
    HomiSettingsSelectors.selectRefreshSettingsLoading,
  );
  public syncLoading: Signal<boolean> = this.store.selectSignal(
    HomiSettingsSelectors.selectSyncLoading,
  );
  public planningIndependent: Signal<boolean> = this.store.selectSignal(
    HomiSettingsSelectors.selectPlanningIndependent,
  );
  public planningShowReflection: Signal<boolean> = this.store.selectSignal(
    HomiSettingsSelectors.selectPlanningShowReflection,
  );
  public planningShowTime: Signal<boolean> = this.store.selectSignal(
    HomiSettingsSelectors.selectPlanningShowTime,
  );

  public connectEloClicked(): void {
    this.store.dispatch(EloActions.connectEloClicked());
  }

  public syncEloClicked(): void {
    this.store.dispatch(EloActions.syncEloClicked());
  }
}
